exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.failed-input[data-v-04a6e8ea] {\n    color: #fd7570\n}\n", ""]);

// exports
